// Units in milliseconds
export const MILLISECONDS_IN_SECOND: number = 1000;
export const MILLISECONDS_IN_MINUTE: number = MILLISECONDS_IN_SECOND * 60;
export const MILLISECONDS_IN_HOUR: number = MILLISECONDS_IN_MINUTE * 60;
export const MILLISECONDS_IN_DAY: number = MILLISECONDS_IN_HOUR * 24;
export const MILLISECONDS_IN_YEAR: number = MILLISECONDS_IN_DAY * 365;
